module.exports = __webpack_public_path__ + "img/LeaveManagement.b534b6e5.svg";